export default __webpack_public_path__ + "static/media/airdockz-wht-banner-1.849c3389.jpg";